import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from 'components/shared/icon';

import { trackClick } from 'hooks/tracking';
import useContent from 'hooks/content';

import useStyles from 'isomorphic-style-loader/useStyles';
import classes from './style.module.scss';
import globalStyles from 'styles/main.scss';
import './translations';

export default () => {
	useStyles(classes, globalStyles);
	const { t } = useTranslation('follow');
	const { getSocialMedia } = useContent();

	const [data, setData] = useState();

	useEffect(() => {
		const getData = async() => {
			const socialMedia = await getSocialMedia();
			setData(socialMedia);
		}

		getData();
	}, []);

	return (
		<div className={`${classes.icons} ${globalStyles.flexCenter}`}>
			<span className={classes.followUs}>
				{ t('followUs') }
			</span>
			<div className={globalStyles.flexJustifyCenter}>
				{
					data && data.map((network, index) =>
						<a 
							target='_blank'
							rel='noopener noreferrer'
							href={network.url}
							title={network.title}
							onClick={() => trackClick(`Link header red social ${network.title}`)}
							key={index}
							className={globalStyles.mlr5}
						>
							<Icon classes={classes.icon} name={`${network.icon}`} />
						</a>
					)
				}
			</div>
		</div>
	);
}